import Api from '../Api';

const path = '/artist/register';

const RegisterArtistRequests = {
	submitForm: (data: any) => {
		return Api.post(path, data);
	},
};

export default RegisterArtistRequests;
